import React from "react";
import { RiskAgentData } from "../../Components/interface";
import { ScoreRadarChart } from "../ScoreRadarChart";
import { PercentageChart } from "../PercentageChart";

export const RiskAgentComponent = ({
  data,
}: {
  data: RiskAgentData | null;
}) => {
  if (!data) return <div>Loading layout...</div>;

  const chartData = [
    { subject: "Liquidity", value: data.risk_categories.liquidity_risk ?? 0 },
    {
      subject: "Wash Trade",
      value: data.risk_categories.wash_trading_risk ?? 0,
    },
    {
      subject: "Holders",
      value: data.risk_categories.holder_concentration_risk ?? 0,
    },
    { subject: "Volatility", value: data.risk_categories.volatility_risk ?? 0 },
    {
      subject: "Integrity",
      value: data.risk_categories.market_integrity_risk ?? 0,
    },
  ];

  return (
    <div className="risk-report">
      <div className="risk-report-header">
        <div className="risk-report-title">RISK AGENT REPORT</div>

        <div className="risk-report-pills">
          <div className="risk-pill risk-pill-high">
            {data.risk_state.toUpperCase()}
          </div>

          <div className="risk-pill risk-pill-score">
            {data.overall_risk_score} RISK SCORE
          </div>

          <div className="risk-pill risk-pill-confidence">
            {data.confidence_score} CONFIDENCE
          </div>
        </div>
      </div>

      {/* SUMMARY */}

      <div className="risk-summary-section">
        <div className="risk-section-title">Structural Risk Summary</div>

        <div className="risk-summary">{data.risk_summary}</div>
      </div>

      {/* CATEGORY GRID */}

      <div className="risk-category-grid">
        <div>
          <PercentageChart
            label="Liquidity Risk"
            percentage={data.risk_categories.liquidity_risk}
            color="#ffcb77"
          />
        </div>
        <div>
          <PercentageChart
            label="Wash Trading"
            percentage={data.risk_categories.wash_trading_risk}
            color="#ff8b75"
          />
        </div>
        <div>
          <PercentageChart
            label="Holder Risk"
            percentage={data.risk_categories.holder_concentration_risk}
            color="#c792ea"
          />
        </div>
        <div>
          <PercentageChart
            label="Volatility"
            percentage={data.risk_categories.volatility_risk}
            color="#ffad5c"
          />
        </div>
        <div>
          <PercentageChart
            label="Market Integrity"
            percentage={data.risk_categories.market_integrity_risk}
            color="#ff9f9f"
          />
        </div>
        <div>
          <PercentageChart
            label="RISK SCORE"
            percentage={data.overall_risk_score}
            color="#ffb38a"
          />
        </div>
      </div>

      {/* SIGNALS */}

      <div className="risk-block-section">
        <div className="risk-section-title">Risk Signals</div>

        <div className="risk-signals-list">
          {data.risk_signals.map((signal, index) => (
            <div key={index} className="risk-signal">
              {signal}
            </div>
          ))}
        </div>
      </div>

      {/* SUSPICIOUS PATTERNS */}

      <div className="risk-block-section">
        <div className="risk-section-title">Suspicious Patterns</div>

        <div className="risk-patterns-list">
          {data.suspicious_patterns.map((signal, index) => (
            <div key={index} className="risk-pattern">
              {signal}
            </div>
          ))}
        </div>
      </div>

      {/* INTERPRETATION */}

      <div className="risk-interpretation-section">
        <div className="risk-section-title">Risk Interpretation</div>

        <div className="risk-interpretation">{data.risk_interpretation}</div>
      </div>
    </div>
  );
};
